import { dispatchPromise, fetchResources } from './action-helpers';

import { getCurrentUserId } from '../services/store-service';

const DEFAULT_SUBTEAM_PROPS = {
    id: null,
    members: [],
    name: '',
    owner: null
};

export const fetchSubteams = all => fetchResources('SUBTEAMS_FETCH_REQUESTED', {}, all);

export const createSubteam = subteamProps => {
    return dispatchPromise({
        type: 'SUBTEAM_CREATE_REQUESTED',
        payload: {
            subteam: Object.assign({}, DEFAULT_SUBTEAM_PROPS, subteamProps, {
                owner: getCurrentUserId()
            })
        }
    }).then(({ id: subteamId }) => {
        if (subteamProps.members && subteamProps.members.length) {
            return new Promise(resolve => {
                setTimeout(() => {
                    return resolve(addSubteamMembers(subteamId, subteamProps.members).then(() => subteamId));
                }, 300);
            })
        }

        return subteamId;
    });
}

export const fetchSubteam = subteamId => {
    return dispatchPromise({
        type: 'SUBTEAM_FETCH_REQUESTED',
        payload: {
            subteamId
        }
    });
}

export const updateSubteam = (subteamId, subteamProps, preventSave) => {
    return dispatchPromise({
        type: 'SUBTEAM_UPDATE_REQUESTED',
        preventSave,
        payload: {
            subteamId,
            subteamProps
        }
    });
}

export const removeSubteam = (subteamId, removeOptions = {}) => {
    return dispatchPromise({
        type: 'SUBTEAM_REMOVE_REQUESTED',
        payload: {
            subteamId,
            removeOptions
        }
    });
}

export const transferSubteam = (subteamId, userId) => {
    return dispatchPromise({
        type: 'SUBTEAM_TRANSFER_REQUESTED',
        payload: {
            subteamId,
            userId
        }
    });
}

export const leaveSubteam = subteamId => {
    return dispatchPromise({
        type: 'SUBTEAM_LEAVE_REQUESTED',
        payload: {
            subteamId,
            userId: getCurrentUserId()
        }
    });
}

export const addSubteamMembers = (subteamId, users) => {
    return dispatchPromise({
        type: 'SUBTEAM_ADD_MEMBERS_REQUESTED',
        payload: {
            subteamId,
            users
        }
    });
}

export const removeSubteamMembers = (subteamId, users) => {
    return dispatchPromise({
        type: 'SUBTEAM_REMOVE_MEMBERS_REQUESTED',
        payload: {
            subteamId,
            users
        }
    });
}
